import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import {
  collection,
  onSnapshot,
  doc,
  updateDoc,
} from "firebase/firestore";
import { Check, X, Star } from "lucide-react";

export default function PendingCommentsTab({ showStatus }) {
  const [firms, setFirms] = useState([]);
  const [activeTab, setActiveTab] = useState("pending");

  useEffect(() => {
    const unsub = onSnapshot(collection(db, "firmalar"), (snap) => {
      const data = snap.docs.map((d) => ({
        id: d.id,
        ...d.data(),
      }));

      setFirms(data);
    });

    return () => unsub();
  }, []);

  // sadece onaysız yorumları çıkar
  const pendingComments = firms.flatMap((firm) =>
    (firm.yorumlar || [])
      .map((y, index) => ({
        ...y,
        firmId: firm.id,
        firmaAdi: firm.firmaAdi,
        index,
      }))
      .filter((y) => y.onay !== true)
  );

  const approvedComments = firms.flatMap((firm) =>
    (firm.yorumlar || [])
      .map((y, index) => ({
        ...y,
        firmId: firm.id,
        firmaAdi: firm.firmaAdi,
        index,
      }))
      .filter((y) => y.onay === true)
  );

  const handleApprove = async (item) => {
    try {
      const firmRef = doc(db, "firmalar", item.firmId);
      const firm = firms.find((f) => f.id === item.firmId);

      const updated = [...(firm.yorumlar || [])];
      updated[item.index].onay = true;

      await updateDoc(firmRef, {
        yorumlar: updated,
      });

      showStatus("success", "Yorum onaylandı");
    } catch (err) {
      showStatus("error", "Hata: " + err.message);
    }
  };

  const handleReject = async (item) => {
    try {
      const firmRef = doc(db, "firmalar", item.firmId);
      const firm = firms.find((f) => f.id === item.firmId);

      const updated = (firm.yorumlar || []).filter(
        (_, i) => i !== item.index
      );

      await updateDoc(firmRef, {
        yorumlar: updated,
      });

      showStatus("success", "Yorum silindi");
    } catch (err) {
      showStatus("error", "Hata: " + err.message);
    }
  };

  const list =
  activeTab === "pending" ? pendingComments : approvedComments;

  return (
    <div className="space-y-4">
      {pendingComments.length === 0 && (
        <p className="text-sm text-slate-400">
          Onay bekleyen yorum yok.
        </p>
      )}

<div className="flex gap-2 mb-4">
  <button
    onClick={() => setActiveTab("pending")}
    className={`px-4 py-2 rounded-lg text-sm font-semibold transition ${
      activeTab === "pending"
        ? "bg-[#243f4d] text-white"
        : "bg-white border border-slate-200 text-slate-600"
    }`}
  >
    Onay Bekleyenler
  </button>

  <button
    onClick={() => setActiveTab("approved")}
    className={`px-4 py-2 rounded-lg text-sm font-semibold transition ${
      activeTab === "approved"
        ? "bg-[#243f4d] text-white"
        : "bg-white border border-slate-200 text-slate-600"
    }`}
  >
    Tüm Yorumlar
  </button>
</div>

{list.length === 0 && (
  <p className="text-sm text-slate-400">
    {activeTab === "pending"
      ? "Onay bekleyen yorum yok."
      : "Hiç yorum yok."}
  </p>
)}
      {list.map((item, i) => (
        <div
          key={i}
          className="bg-white border border-slate-200 rounded-xl p-4 shadow-sm"
        >
          <div className="flex justify-between mb-2">
            <div>
              <p className="text-sm font-bold text-slate-800">
                {item.name}
              </p>

              <p className="text-xs text-slate-400">
                {item.firmaAdi}
              </p>

              <div className="flex mt-1">
                {[1,2,3,4,5].map((s) => (
                  <Star
                    key={s}
                    className={`w-4 h-4 ${
                      s <= item.puan
                        ? "fill-amber-400 text-amber-400"
                        : "text-slate-300"
                    }`}
                  />
                ))}
              </div>
            </div>

            <span className="text-xs text-slate-400">
              {item.tarih?.toDate
                ? item.tarih.toDate().toLocaleDateString("tr-TR")
                : ""}
            </span>
          </div>

          <p className="text-sm text-slate-600 mb-3">
            {item.yorum}
          </p>

          <div className="flex gap-2">
            <button
              onClick={() => handleApprove(item)}
              className="px-3 py-2 bg-emerald-500 hover:bg-emerald-600 text-white text-xs rounded-lg flex items-center gap-1"
            >
              <Check className="w-4 h-4" />
              Onayla
            </button>

            <button
              onClick={() => handleReject(item)}
              className="px-3 py-2 bg-red-500 hover:bg-red-600 text-white text-xs rounded-lg flex items-center gap-1"
            >
              <X className="w-4 h-4" />
              Sil
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}